import React from 'react';
import classNames from 'classnames';
import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';

const RenderStartUpload = ({ fileUpload, fileUploadRef, message }) => {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop(item) {
        fileUpload(null, item.files);
      },
      collect: monitor => {
        return {
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
        };
      },
    }),
    [],
  );
  const fileUploadClasses = classNames('ElearningFileUpload-uploadArea', {
    'ElearningFileUpload--isOver': isOver,
  });
  return (
    <div ref={drop} className={fileUploadClasses} data-testid="fileUploadBlock">
      <div className="ElearningFileUpload-description">{message}</div>
      <div
        role="button"
        className="ElearningFileUpload-button NewButton NewButton--center NewButton--white"
        tabIndex="0"
        onKeyDown={e => e.key === 'Enter' && fileUploadRef.current.click()}
        onClick={() => fileUploadRef.current.click()}
      >
        <span>{t('questions.types.elearning.file_upload.browse')}</span>
      </div>
    </div>
  );
};

export default RenderStartUpload;
